<template>
	<div class="per_right">
		<div class="per_right_1 clearfix">
			<img src="@/images/center_title.png" class="per_right_1back"/>
			<img src="@/images/center_text7.png" class="per_right_1name"/>
		</div>
		<div class="per_right_2">
			<div class="right-filter" v-if="activeName == 'first'">
				<el-form :inline="true" :model="params">
					<el-form-item label="帖子查找：">
						<el-input v-model="params.title" placeholder="请输入帖子关键词" clearable></el-input>
					</el-form-item>
					<el-form-item label="帖子板块：">
						<el-select v-model="params.pid" placeholder="帖子板块" clearable>
							<el-option :label="item.name" :value="item.id" :key="item.value" v-for='item in plates'></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<div class="feedback_button" @click="onSubmit">
							<img src="@/images/zy_button.png" class="feedback_back" />
							<span>查询</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div class="news_right_con">
				<el-tabs type="border-card" v-model="activeName">
					<el-tab-pane label="我的帖子" name="first">
						<div v-if="!tableData || tableData.length<=0" class="simulation_empty_msg_content">暂无帖子</div>
						<div class="clearfix zy_postmain" v-if="tableData && tableData.length>0">
							<div class="zy_post_item zy_post_itembig" v-for="(item,index) in tableData" @click="jump(item)">
								<div class="zy_post_itemP1">
									<img src="@/images/zy_point_l.png" class="zy_postpoint" /> {{item.title}}
								</div>
								<div class="zy_post_itemP2 text-ellipsis">
									{{item.remark || '暂无描述'}}
								</div>
								<div class="zy_post_itemP3">
									<span class="l">发帖人：{{item.createUser}}</span>
									<span class="l">|</span>
									<span class="l">{{item.createtime}}</span>
									<span class="l">|</span>
									<span class="l zy_color">#<span v-for="it in plates" v-if="item.pid == it.id">{{it.name}}</span></span>
									<span class="r">
									<img src="@/images/iconshow.png" class="com_show"/>{{item.watchcount || 0}}
				  					<img src="@/images/I-iconmess2.png" class="com_mess2"/>{{item.chilnum || 0}}
								</span>
								</div>
							</div>
						</div>
						<div class="table-page" v-show="tableData.length>0">
							<el-pagination background @current-change="currentChange" :current-page="current" :page-size="limit" layout="  prev, pager, next" :total="total"></el-pagination>
						</div>
					</el-tab-pane>
					<el-tab-pane label="我的评论" name="second">
						<div class="noimg" v-show='comTableData.length <= 0'>
							<div class="noimgcont">
								<img src="@/images/no.png" />
							</div>
							<div>
								暂未发布评论/回复
							</div>
						</div>
						<div class="news_p clearfix" v-for="(item,index) in comTableData">
							<div class="news_head">
								<img :src="baseurl + item.iconFile" v-if="item.iconFile" />
								<img src="@/images/stu.png" v-else/>
							</div>
							<div class="news_words" v-show="item.rcontent">
								<p class="news_p_name" >我&nbsp;
									<span style="color: #F89B47;" >回复</span>&nbsp;
									<span class="info-replysname" >{{item.rreplyToName}}</span>
									<span class="r delete_post" @click="deletecom(item)"><i class="el-icon-delete-solid"></i></span>
								</p>
								<p class="news_p_speak" >{{item.rcontent}}</p>
								<p class="news_p_comment news_p_comment_sp" >
									<span style="color: #CCCCCC;">相关评论：</span><span class="info-replysname" >{{item.replyToName}}:</span>{{item.rmaincontent}}
								</p>
								<p class="post_p_3 post_p_2">
									回复时间：<span>{{item.rcreateTime}}</span>
								</p>
							</div>
							<div class="news_words" v-show="!item.rcontent">
								<p class="news_p_name" >我
									<span style="color: #F89B47;">评论</span>
									<span class="r delete_post" @click="deletecom(item)"><i class="el-icon-delete-solid"></i></span>
								</p>
								<p class="news_p_speak" >{{item.content}}</p>
								<p class="news_p_comment news_p_comment_sp" >
									<span style="color: #CCCCCC;">相关帖子：</span>{{item.maincontent}}
								</p>
								<p class="post_p_3 post_p_2">
									评论时间：<span>{{item.createTime}}</span>
								</p>
							</div>
						</div>
						<div class="table-page">
							<el-pagination background @current-change="comCurrentChange" :current-page="comCurrent" :page-size="limit" layout="  prev, pager, next" :total="comTotal"></el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	</div>
</template>

<script>
	import { getInfo } from '@/api/user.js'
	import { plateList } from '@/api/plate.js'
	import { getMyTopic, deltopic, getMyAnswer, delcomment } from '@/api/client.js'
	export default {
		props: {
			majorid: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				activeName: 'first',
				userinfo: {},
				params: {
					title: '',
					pid: '',
				},
				plates: [],
				tableData: [],
				limit: 10,
				total: 0,
				current: 1,
				comTableData: [],
				comTotal: 0,
				comCurrent: 1,
			}
		},
		created() {
			this.getMyInfo();
			this.getAnswer();
			this.getDataList();
			this.getPlateList();
		},
		methods: {
			jump(item) {
				this.$router.push({
					path: '/communicationDetails',
					query: {
						id: item.id
					}
				});
			},
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
				})
			},
			comCurrentChange(page) {
				this.comCurrent = page;
				this.getAnswer();
			},
			getAnswer() {
				var data = {
					current: this.comCurrent,
					size: this.limit,
				}
				getMyAnswer(data).then(res => {
					this.comTableData = res.data.records;
					this.comTotal = res.data.total;
				})
			},
			deletecom(item) {
				this.$confirm('确认删除这条评论/回复吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delcomment({
						uid: this.userinfo.userId,
						rid: item.rid,
						cid: item.cid
					}).then(async res => {
						if(res.code == 'OK') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getAnswer();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					this.$notify({
						title: '提示',
						type: 'info',
						message: '已取消'
					});
				});
			},
			currentChange(page) {
				this.current = page;
				this.getDataList();
			},
			getDataList() {
				var data = {
					current: this.current,
					size: this.limit,
					title: this.params.title ? this.params.title : null,
					pid: this.params.pid ? this.params.pid : null,
					gid: this.majorid,
				}
				getMyTopic(data).then(res => {
					this.tableData = res.data.records;
					this.total = res.data.total;
				})
			},
			deletepost(item) {
				this.$confirm('确认删除这个帖子吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deltopic({
						id: item.id
					}).then(async res => {
						if(res.code == 'OK') {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getDataList();
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch(() => {
					this.$notify({
						title: '提示',
						type: 'info',
						message: '已取消'
					});
				});
			},
			getPlateList() {
				plateList({
					size: 100,
					current: 1,
					gid: this.majorid,
				}).then(res => {
					this.plates = res.data.records;
				})
			},
			onSubmit() {
				this.current = 1;
				this.getDataList();
			},
		}
	}
</script>

<style>

</style>